export type SchedulerReviewSection = {
  id: 'draft-review' | 'request-queue';
  navLabel: string;
  path: string;
  title: string;
  description: string;
};

export const schedulerReviewSections: SchedulerReviewSection[] = [
  {
    id: 'draft-review',
    navLabel: 'Draft Review',
    path: '/scheduling/draft-review',
    title: 'Draft Review',
    description: 'Read-only scheduler review shell for explainability, conflict triage, and publish readiness before direct schedule editing exists.',
  },
  {
    id: 'request-queue',
    navLabel: 'Request Queue',
    path: '/scheduling/request-queue',
    title: 'Request Queue',
    description: 'Scoped scheduling-admin queue for approval visibility, decision notes, and tenant-safe request handling.',
  },
];
